import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  Button,
} from "@chakra-ui/react";
import { JobProto } from "build-ts/jobs_interface";

interface DeleteJobModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedJob: JobProto | null;
  handleDeleteJob: (id: string) => Promise<void>;
}

const DeleteJobModal: React.FC<DeleteJobModalProps> = ({
  isOpen,
  onClose,
  selectedJob,
  handleDeleteJob,
}) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader fontSize="md">Are you sure you want to delete?</ModalHeader>
      <ModalCloseButton />
      <ModalFooter>
        <Button
          colorScheme="purple"
          mr={3}
          onClick={async () => {
            await handleDeleteJob(selectedJob?.header?.id!);
            onClose();
          }}
        >
          OK
        </Button>
        <Button variant="ghost" onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default DeleteJobModal;
